import { ServiceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export const serviceTypes: ServiceTypeEnum[] = [
  'curb-to-curb',
  'door-to-door',
  'door-through-door',
  'person-to-person',
];
